import { useQuery } from '@tanstack/react-query';
import { getReportExecutions, type GetReportExecutionsParams, type ReportExecutionsResponse } from '@/api/reports';

/**
 * React Query hook for fetching report executions with pagination and filtering
 */
export const useReportExecutions = (params: GetReportExecutionsParams = {}) => {
  return useQuery<ReportExecutionsResponse>({
    queryKey: ['reportExecutions', params],
    queryFn: () => getReportExecutions(params),
    staleTime: 30000, // Consider data fresh for 30 seconds
    gcTime: 5 * 60 * 1000, // Keep in cache for 5 minutes
  });
};
